import { useEffect, useState } from "react";

const TARGET = new Date("2028-01-01T00:00:00");

function remaining() {
  const ms = Math.max(0, TARGET.getTime() - Date.now());
  const total = Math.floor(ms / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    mins: Math.floor((total % 3600) / 60),
    secs: total % 60,
  };
}

export function daysLeft() {
  return Math.max(0, Math.floor((TARGET.getTime() - Date.now()) / 86400000));
}

function Box({ value, label }) {
  return (
    <div className="min-w-[64px] rounded-xl border border-[#e6b800]/25 bg-[#0a0a0e] px-3 py-2.5 text-center" data-testid="countdown-box">
      <p className="font-display text-2xl font-extrabold text-[#e6b800] sm:text-3xl">{String(value).padStart(2, "0")}</p>
      <p className="mt-0.5 text-[9px] uppercase tracking-[0.18em] text-neutral-500">{label}</p>
    </div>
  );
}

export default function Countdown() {
  const [t, setT] = useState(remaining());

  useEffect(() => {
    const iv = setInterval(() => setT(remaining()), 1000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="flex items-stretch justify-center gap-2.5 sm:gap-3" data-testid="delivery-countdown">
      <Box value={t.days} label="दिन" />
      <Box value={t.hours} label="घंटे" />
      <Box value={t.mins} label="मिनट" />
      <Box value={t.secs} label="सेकंड" />
    </div>
  );
}
